import { render, staticRenderFns } from "./ServicePlaceInformationAddEdit.vue?vue&type=template&id=dd6169bc&scoped=true"
import script from "./ServicePlaceInformationAddEdit.vue?vue&type=script&lang=js"
export * from "./ServicePlaceInformationAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ServicePlaceInformationAddEdit.vue?vue&type=style&index=0&id=dd6169bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6169bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd6169bc')) {
      api.createRecord('dd6169bc', component.options)
    } else {
      api.reload('dd6169bc', component.options)
    }
    module.hot.accept("./ServicePlaceInformationAddEdit.vue?vue&type=template&id=dd6169bc&scoped=true", function () {
      api.rerender('dd6169bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/specialist-tab/components/ServicePlaceInformationAddEdit.vue"
export default component.exports